/**
 * Luxury Product Page — Nike-style PDP interactions
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function parseJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  ready(function () {
    var wrapper = document.getElementById('luxury-product-page');
    if (!wrapper) return;

    var productData = parseJSON('lpp-product-json');
    var settings = parseJSON('lpp-settings-json') || {};
    if (!productData) return;

    var state = {
      selectedVariantId: null,
      selectedSize: null,
      currentImageIndex: 0,
      addingToCart: false
    };

    /* ── DOM refs ── */
    var mainImg = document.getElementById('lpp-main-img');
    var mainImageWrap = document.getElementById('lpp-main-image');
    var thumbs = document.querySelectorAll('.lpp-thumb');
    var sizeBtns = document.querySelectorAll('.lpp-size-btn');
    var addToBagBtn = document.getElementById('lpp-add-to-bag');
    var favoriteBtn = document.getElementById('lpp-favorite');
    var priceEl = wrapper.querySelector('.lpp-price');
    var urgencyEl = document.getElementById('lpp-urgency');
    var modalOverlay = document.getElementById('lpp-modal-overlay');
    var modalClose = document.getElementById('lpp-modal-close');
    var viewDetailsBtn = document.getElementById('lpp-view-details-btn');
    var sizeGuideMenu = document.getElementById('lpp-size-guide-menu');
    var sizeGuideTrigger = document.getElementById('lpp-size-guide-trigger');
    var sizeGuideDropdown = document.getElementById('lpp-size-guide-dropdown');
    var sizeGuideQuick = document.getElementById('lpp-size-guide-quick');
    var sizeGuideOverlay = document.getElementById('lpp-size-guide-modal-overlay');
    var sizeGuideModal = document.getElementById('lpp-size-guide-modal');
    var sizeGuideClose = document.getElementById('lpp-size-guide-close');
    var mobileTrack = document.getElementById('lpp-mobile-track');
    var mobileDots = document.querySelectorAll('.lpp-mobile-dot');
    var mobileFavorite = document.getElementById('lpp-mobile-favorite');
    var mobilePriceEl = document.getElementById('lpp-mobile-price');
    var stickyBar = document.getElementById('lpp-mobile-sticky-bar');
    var stickyAtc = document.getElementById('lpp-mobile-sticky-atc');

    /* ── Gallery ── */
    function setMainImage(index) {
      if (!productData.images || !productData.images.length) return;
      var idx = ((index % productData.images.length) + productData.images.length) % productData.images.length;
      state.currentImageIndex = idx;
      var img = productData.images[idx];
      if (!mainImg || !img) return;

      mainImg.classList.add('lpp-img-fade');
      setTimeout(function () {
        mainImg.srcset = '';
        mainImg.src = img.src;
        mainImg.alt = img.alt || productData.title;
        mainImg.classList.remove('lpp-img-fade');
      }, settings.animationSpeed ? settings.animationSpeed / 2 : 150);

      thumbs.forEach(function (t, i) {
        t.classList.toggle('lpp-thumb--active', i === idx);
      });

      setMobileImageSlide(idx);
    }

    function setMobileSlide(index) {
      if (!mobileTrack) return;
      var slides = mobileTrack.querySelectorAll('.lpp-mobile-slide');
      if (!slides.length) return;
      var idx = ((index % slides.length) + slides.length) % slides.length;
      state.currentMobileIndex = idx;
      mobileTrack.style.transform = 'translateX(-' + idx * 100 + '%)';
      mobileDots.forEach(function (dot, i) {
        dot.classList.toggle('lpp-mobile-dot--active', i === idx);
        dot.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    function setMobileImageSlide(imageIndex) {
      if (!mobileTrack) return;
      var slide = mobileTrack.querySelector('.lpp-mobile-slide[data-image-index="' + imageIndex + '"]');
      if (slide) setMobileSlide(parseInt(slide.dataset.index, 10));
    }

    /* Instant (no-fade) image swap — used for hover so the gallery feels snappy. */
    function setMainImageInstant(index) {
      if (!productData.images || !productData.images.length || !mainImg) return;
      var idx = ((index % productData.images.length) + productData.images.length) % productData.images.length;
      var img = productData.images[idx];
      if (!img) return;
      state.currentImageIndex = idx;
      mainImg.classList.remove('lpp-img-fade');
      mainImg.srcset = '';
      mainImg.src = img.src;
      mainImg.alt = img.alt || productData.title;
      thumbs.forEach(function (t, i) {
        t.classList.toggle('lpp-thumb--active', i === idx);
      });
      setMobileImageSlide(idx);
    }

    thumbs.forEach(function (thumb) {
      var idx = parseInt(thumb.dataset.index, 10);
      /* Hover opens the image immediately (no click needed). */
      thumb.addEventListener('mouseenter', function () {
        if (!isNaN(idx)) setMainImageInstant(idx);
      });
      /* Keep click for touch devices / accessibility. */
      thumb.addEventListener('click', function () {
        if (!isNaN(idx)) setMainImage(idx);
      });
      thumb.addEventListener('focus', function () {
        if (!isNaN(idx)) setMainImageInstant(idx);
      });
    });

    /* Preload full-size gallery images during idle time so hover swaps are instant. */
    function preloadGallery() {
      (productData.images || []).forEach(function (im) {
        if (!im || !im.src) return;
        var pre = new Image();
        pre.src = im.src;
      });
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadGallery);
    } else {
      window.addEventListener('load', function () { setTimeout(preloadGallery, 800); });
    }

    mobileDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        if (!isNaN(idx)) setMobileSlide(idx);
      });
    });

    if (mobileTrack) {
      var touchStartX = 0;
      var touchDeltaX = 0;
      mobileTrack.parentElement.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
          touchDeltaX = 0;
        },
        { passive: true }
      );
      mobileTrack.parentElement.addEventListener(
        'touchmove',
        function (e) {
          touchDeltaX = e.changedTouches[0].screenX - touchStartX;
        },
        { passive: true }
      );
      mobileTrack.parentElement.addEventListener(
        'touchend',
        function () {
          if (Math.abs(touchDeltaX) < 40) return;
          var currentMobileIndex = state.currentMobileIndex || 0;
          if (touchDeltaX < 0) setMobileSlide(currentMobileIndex + 1);
          else setMobileSlide(currentMobileIndex - 1);
        },
        { passive: true }
      );
    }

    /* ── Size selection ── */
    function selectSize(btn) {
      sizeBtns.forEach(function (b) {
        b.classList.remove('lpp-size-btn--active');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('lpp-size-btn--active');
      btn.setAttribute('aria-checked', 'true');
      state.selectedVariantId = parseInt(btn.dataset.variantId, 10);
      state.selectedSize = btn.dataset.size;

      var variant = productData.variants.find(function (v) {
        return v.id === state.selectedVariantId;
      });
      if (variant) {
        updatePrice(variant);
        updateUrgency(variant);
        updateAddToBagState(variant);
        if (variant.featured_image && variant.featured_image.src && mainImg) {
          mainImg.classList.add('lpp-img-fade');
          setTimeout(function () {
            mainImg.srcset = '';
            mainImg.src = variant.featured_image.src;
            mainImg.classList.remove('lpp-img-fade');
          }, settings.animationSpeed ? settings.animationSpeed / 2 : 150);
        }
      }
    }

    function updatePrice(variant) {
      if (!variant) return;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html =
          '<span class="lpp-price--sale">' +
          formatMoney(variant.price) +
          '</span>' +
          '<span class="lpp-price--compare">' +
          formatMoney(variant.compare_at_price) +
          '</span>';
      } else {
        html = formatMoney(variant.price);
      }
      document.querySelectorAll('.lpp-price').forEach(function (el) {
        el.innerHTML = html;
      });
    }

    function updateUrgency(variant) {
      if (!urgencyEl || !settings.showUrgency) return;
      var qty = variant ? variant.inventory_quantity : 0;
      var threshold = settings.urgencyThreshold || 5;
      var show =
        variant &&
        variant.available &&
        variant.inventory_management === 'shopify' &&
        qty > 0 &&
        qty <= threshold;
      urgencyEl.style.display = show ? 'flex' : 'none';
    }

    /* A tracked variant with no stock on hand is "out of stock". What we do with it
       depends on the variant's inventory policy in Shopify admin:
         - "Continue selling when out of stock" (inventory_policy === 'continue')
           → orderable as a PRE-ORDER (Shopify accepts the add to cart).
         - "Stop selling" (inventory_policy === 'deny', the default)
           → Shopify would REJECT the add, so we open the NOTIFY ME form instead.
       We never show "Sold Out". */
    function isOutOfStock(variant) {
      if (!variant) return false;
      var tracked = !!variant.inventory_management; // 'shopify' = tracked, null = always available
      return tracked && variant.inventory_quantity <= 0;
    }

    function isPreOrder(variant) {
      return isOutOfStock(variant) && variant.inventory_policy === 'continue';
    }

    function isNotifyOnly(variant) {
      return isOutOfStock(variant) && variant.inventory_policy !== 'continue';
    }

    /* Reels-page items are made-to-order one-offs: when a reels product's
       selected variant is out of stock, it must NOT be pre-orderable or
       notifiable — the button is fully disabled to avoid duplicate orders.
       Two checks: the product is tagged as a reel AND the variant has no stock. */
    function isReelsSoldOut(variant) {
      return productData.isReels === true && !!variant && Number(variant.inventory_quantity) <= 0;
    }

    /* The button's resting label for the currently selected variant. */
    function idleAddToBagLabel() {
      var variant = productData.variants.find(function (v) {
        return v.id === state.selectedVariantId;
      });
      if (isReelsSoldOut(variant)) return settings.reelsSoldOutText || 'Sold Out';
      if (isNotifyOnly(variant)) return settings.notifyText || 'Notify Me When Available';
      if (isPreOrder(variant)) return settings.preOrderText || 'Pre-Order';
      return settings.addToBagText || 'Add to Bag';
    }

    function updateAddToBagState(variant) {
      if (!addToBagBtn) return;
      addToBagBtn.classList.remove('lpp-btn--preorder', 'lpp-btn--notify', 'lpp-btn--soldout');

      // Reels item + no stock → hard stop. No pre-order, no notify, no add.
      if (isReelsSoldOut(variant)) {
        addToBagBtn.textContent = settings.reelsSoldOutText || 'Sold Out';
        addToBagBtn.classList.add('lpp-btn--soldout');
        addToBagBtn.disabled = true;
        if (stickyAtc) {
          stickyAtc.textContent = addToBagBtn.textContent;
          stickyAtc.classList.remove('lpp-btn--preorder', 'lpp-btn--notify');
          stickyAtc.classList.add('lpp-btn--soldout');
          stickyAtc.disabled = true;
        }
        return;
      }

      if (isNotifyOnly(variant)) {
        addToBagBtn.textContent = settings.notifyText || 'Notify Me When Available';
        addToBagBtn.classList.add('lpp-btn--notify');
      } else if (isPreOrder(variant)) {
        addToBagBtn.textContent = settings.preOrderText || 'Pre-Order';
        addToBagBtn.classList.add('lpp-btn--preorder');
      } else {
        addToBagBtn.textContent = settings.addToBagText || 'Add to Bag';
      }
      addToBagBtn.disabled = false;
      if (stickyAtc) {
        stickyAtc.disabled = false;
        stickyAtc.classList.remove('lpp-btn--soldout');
        stickyAtc.textContent = addToBagBtn.textContent;
        stickyAtc.classList.toggle('lpp-btn--preorder', addToBagBtn.classList.contains('lpp-btn--preorder'));
        stickyAtc.classList.toggle('lpp-btn--notify', addToBagBtn.classList.contains('lpp-btn--notify'));
      }
    }

    /* Every size is selectable — out-of-stock sizes become pre-orderable. */
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSize(btn);
      });
    });

    /* Auto-select first available size, otherwise the first size (still orderable as pre-order) */
    var firstAvailable = Array.prototype.find.call(sizeBtns, function (b) {
      return b.dataset.available === 'true';
    });
    if (firstAvailable) {
      selectSize(firstAvailable);
    } else if (sizeBtns.length) {
      selectSize(sizeBtns[0]);
    } else if (productData.variants && productData.variants.length) {
      var defaultVariant =
        productData.variants.find(function (v) {
          return v.available;
        }) || productData.variants[0];
      state.selectedVariantId = defaultVariant.id;
      updatePrice(defaultVariant);
      updateUrgency(defaultVariant);
      updateAddToBagState(defaultVariant);
    }

    /* ── Color swatches (variant mode) ──
       Mode A (linked sibling products) renders plain <a> links and needs no JS.
       Mode B renders <button data-color-swatch> per color value; clicking one
       re-points the size buttons to that color's variants and reuses selectSize. */
    var colorSwatches = wrapper.querySelectorAll('.lpp-swatch[data-color-swatch]');
    if (colorSwatches.length) {
      /* Apply a variant's stock state to a size button (mirrors the Liquid render). */
      function applyVariantToSizeBtn(btn, v) {
        if (!v) {
          btn.dataset.available = 'false';
          return;
        }
        btn.dataset.variantId = v.id;
        btn.dataset.available = v.available ? 'true' : 'false';
        var oos = isOutOfStock(v);
        btn.dataset.preorder = oos ? 'true' : 'false';
        btn.classList.toggle('lpp-size-btn--preorder', oos);
        var labelText = isReelsSoldOut(v)
          ? (settings.reelsSoldOutText || 'Sold Out')
          : (isNotifyOnly(v) ? 'Notify Me' : (isPreOrder(v) ? 'Pre-Order' : ''));
        var label = btn.querySelector('.lpp-size-oos-label');
        if (labelText) {
          if (!label) {
            label = document.createElement('span');
            label.className = 'lpp-size-oos-label';
            btn.appendChild(label);
          }
          label.textContent = labelText;
        } else if (label) {
          label.parentNode.removeChild(label);
        }
      }

      /* Find the variant that matches a color (and optionally a size) by option values. */
      function variantForColor(color, size) {
        return productData.variants.find(function (v) {
          var opts = v.options || [];
          var colorOk = opts.indexOf(color) !== -1;
          var sizeOk = size == null || opts.indexOf(size) !== -1;
          return colorOk && sizeOk;
        });
      }

      function selectColor(swatch) {
        var color = swatch.dataset.color;
        /* Sync active state across both mobile + desktop swatch sets. */
        colorSwatches.forEach(function (s) {
          var on = s.dataset.color === color;
          s.classList.toggle('lpp-swatch--active', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        state.selectedColor = color;

        if (sizeBtns.length) {
          /* Re-point every size button to the variant for (color, size). */
          sizeBtns.forEach(function (btn) {
            applyVariantToSizeBtn(btn, variantForColor(color, btn.dataset.size));
          });
          /* Keep the current size if it's available in this color, else first available. */
          var keep = Array.prototype.find.call(sizeBtns, function (b) {
            return b.dataset.size === state.selectedSize && b.dataset.available === 'true';
          });
          var target =
            keep ||
            Array.prototype.find.call(sizeBtns, function (b) { return b.dataset.available === 'true'; }) ||
            sizeBtns[0];
          if (target) selectSize(target);
        } else {
          /* Color-only product (no size option). */
          var v = variantForColor(color, null);
          if (v) {
            state.selectedVariantId = v.id;
            updatePrice(v);
            updateUrgency(v);
            updateAddToBagState(v);
          }
        }

        /* Swap the gallery image to this color's variant image. */
        if (swatch.dataset.image && mainImg) {
          mainImg.classList.add('lpp-img-fade');
          setTimeout(function () {
            mainImg.srcset = '';
            mainImg.src = swatch.dataset.image;
            mainImg.classList.remove('lpp-img-fade');
          }, settings.animationSpeed ? settings.animationSpeed / 2 : 150);
        }
      }

      colorSwatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          selectColor(swatch);
        });
      });

      /* On load, sync the size buttons to the pre-selected color so availability is correct. */
      var activeSwatch =
        wrapper.querySelector('.lpp-swatch[data-color-swatch].lpp-swatch--active') || colorSwatches[0];
      if (activeSwatch) selectColor(activeSwatch);
    }

    /* ── Add to cart ── */
    function addToCart() {
      if (state.addingToCart) return;

      if (!state.selectedVariantId) {
        wrapper.classList.add('lpp-shake-size');
        setTimeout(function () {
          wrapper.classList.remove('lpp-shake-size');
        }, 500);
        var sizeBlock = document.getElementById('lpp-sizes');
        if (sizeBlock) sizeBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var selectedVariant = productData.variants.find(function (v) {
        return v.id === state.selectedVariantId;
      });

      /* Reels item with no stock → never add to cart (avoids duplicate orders
         on made-to-order one-offs). The button is already disabled; this is the
         second, defensive check. */
      if (isReelsSoldOut(selectedVariant)) {
        return;
      }

      /* Out of stock + overselling OFF → Shopify would reject the add to cart.
         Collect the shopper's details via the Notify Me form instead. */
      if (isNotifyOnly(selectedVariant)) {
        if (typeof window.openNotifyMe === 'function') {
          window.openNotifyMe({
            product: productData.title,
            size: state.selectedSize || '',
            url: window.location.pathname
          });
        }
        return;
      }

      state.addingToCart = true;
      addToBagBtn.setAttribute('aria-busy', 'true');
      addToBagBtn.textContent = settings.addingText || 'Adding…';
      if (stickyAtc) stickyAtc.textContent = addToBagBtn.textContent;

      var root = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) || '/';

      // Collect sections the cart drawer needs so it can re-render without a page reload
      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      /* Add-ons are opted into per product. Linking each add-on line to this
         exact variant keeps it from merging with, or applying to, any other
         item in the cart. */
      var checkedAddons = Array.prototype.slice.call(
        document.querySelectorAll('.gw-addon__input:checked')
      );
      var addonLabels = checkedAddons.map(function (input) {
        return input.dataset.addonLabel;
      });

      var payload = {
        items: [{
          id: state.selectedVariantId,
          quantity: 1,
          properties: addonLabels.length ? { 'Add ons': addonLabels.join(', ') } : {}
        }],
        sections: sectionsToBundle.join(','),
        sections_url: window.location.pathname
      };

      /* "Applies to" is human readable and visible everywhere an order is read:
         admin, packing slip, confirmation email. "_addon_for" is the machine
         key the cart reconciler matches on and stays hidden. */
      var appliesTo = productData.title;
      if (selectedVariant && selectedVariant.title && selectedVariant.title !== 'Default Title') {
        appliesTo += ' / ' + selectedVariant.title;
      }

      checkedAddons.forEach(function (input) {
        payload.items.push({
          id: parseInt(input.dataset.addonVariantId, 10),
          quantity: 1,
          properties: {
            'Applies to': appliesTo,
            '_addon_for': String(state.selectedVariantId)
          }
        });
      });

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || 'Add to cart failed');
            return data;
          });
        })
        .then(function (addResponse) {
          return fetch(root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              // Attach rendered section HTML so cart drawer can update itself
              cart['sections'] = addResponse['sections'] || {};
              // A multi-item add returns { items: [...] } rather than a single line
              var addedItems = addResponse.items || [addResponse];
              // variant:add opens the cart drawer
              document.documentElement.dispatchEvent(
                new CustomEvent('variant:add', {
                  bubbles: true,
                  detail: { items: addedItems, cart: cart }
                })
              );
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:change', {
                  bubbles: true,
                  detail: { baseEvent: 'variant:add', cart: cart }
                })
              );
              // Clear the opt-ins so the next product starts unchecked
              checkedAddons.forEach(function (input) {
                input.checked = false;
              });
              addToBagBtn.textContent = settings.addedText || 'Added ✓';
              setTimeout(function () {
                addToBagBtn.textContent = idleAddToBagLabel();
              }, 2000);
            });
        })
        .catch(function () {
          addToBagBtn.textContent = settings.errorText || 'Try again';
        })
        .finally(function () {
          state.addingToCart = false;
          addToBagBtn.removeAttribute('aria-busy');
          if (stickyAtc) stickyAtc.textContent = idleAddToBagLabel();
        });
    }

    if (addToBagBtn) {
      addToBagBtn.addEventListener('click', addToCart);
    }
    if (stickyAtc) {
      stickyAtc.addEventListener('click', addToCart);
    }

    /* ── Wishlist (GomilaWishlist global) ── */
    function wishlistProductPayload() {
      var img =
        productData.images && productData.images[0] ? productData.images[0].src : '';
      return {
        id: productData.id,
        handle: productData.handle,
        title: productData.title,
        url: window.location.pathname,
        image: img,
        price: formatMoney(productData.price)
      };
    }

    function isFavorited() {
      // Must return a strict boolean: classList.toggle(class, undefined) FLIPS the class
      // instead of removing it, which would falsely fill the heart when GomilaWishlist
      // (a deferred script) hasn't loaded yet at init time.
      return !!(window.GomilaWishlist && window.GomilaWishlist.has(productData.id));
    }

    function updateFavoriteUI() {
      var fav = isFavorited();
      [favoriteBtn, mobileFavorite].forEach(function (btn) {
        if (!btn) return;
        btn.classList.toggle('lpp-favorited', fav);
        btn.setAttribute('aria-pressed', fav ? 'true' : 'false');
      });
    }

    function toggleFavorite() {
      if (!window.GomilaWishlist) return;
      window.GomilaWishlist.toggle(wishlistProductPayload());
      updateFavoriteUI();
    }

    updateFavoriteUI();
    // GomilaWishlist is a deferred script that may load after this one, so re-sync the
    // heart once everything has loaded and whenever the wishlist changes elsewhere.
    window.addEventListener('load', updateFavoriteUI);
    document.addEventListener('wishlist:change', updateFavoriteUI);
    if (favoriteBtn) favoriteBtn.addEventListener('click', toggleFavorite);
    if (mobileFavorite) mobileFavorite.addEventListener('click', toggleFavorite);

    /* ── Accordion ── */
    document.querySelectorAll('.lpp-accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var body = trigger.parentElement.querySelector('.lpp-accordion-body');
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        trigger.classList.toggle('lpp-accordion-trigger--open', !expanded);
        if (body) body.classList.toggle('lpp-accordion-body--open', !expanded);
      });
    });

    /* ── Product details modal ── */
    function openModal() {
      if (!modalOverlay) return;
      modalOverlay.setAttribute('aria-hidden', 'false');
      modalOverlay.classList.add('lpp-modal--open');
      if (settings.popupAnimation) {
        modalOverlay.setAttribute('data-animation', settings.popupAnimation);
      }
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modalOverlay) return;
      modalOverlay.classList.remove('lpp-modal--open');
      modalOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (viewDetailsBtn) viewDetailsBtn.addEventListener('click', openModal);
    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modalOverlay) {
      modalOverlay.addEventListener('click', function (e) {
        if (e.target === modalOverlay) closeModal();
      });
    }

    /* ── Size guide dropdown + quick modal ── */
    function setSizeGuideDropdown(open) {
      if (!sizeGuideTrigger || !sizeGuideDropdown) return;
      sizeGuideDropdown.hidden = !open;
      sizeGuideTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function openSizeGuideModal() {
      if (!sizeGuideOverlay) return;
      setSizeGuideDropdown(false);
      sizeGuideOverlay.setAttribute('aria-hidden', 'false');
      sizeGuideOverlay.classList.add('lpp-modal--open');
      if (settings.popupAnimation) {
        sizeGuideOverlay.setAttribute('data-animation', settings.popupAnimation);
      }
      document.body.style.overflow = 'hidden';
    }

    function closeSizeGuideModal() {
      if (!sizeGuideOverlay) return;
      sizeGuideOverlay.classList.remove('lpp-modal--open');
      sizeGuideOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function selectSizeGuideTab(name) {
      if (!sizeGuideModal) return;
      sizeGuideModal.querySelectorAll('[data-lpp-size-tab]').forEach(function (tab) {
        var active = tab.getAttribute('data-lpp-size-tab') === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      sizeGuideModal.querySelectorAll('[data-lpp-size-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-lpp-size-panel') !== name;
      });
    }

    if (sizeGuideTrigger) {
      sizeGuideTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        var open = sizeGuideTrigger.getAttribute('aria-expanded') === 'true';
        setSizeGuideDropdown(!open);
      });
    }
    if (sizeGuideQuick) sizeGuideQuick.addEventListener('click', openSizeGuideModal);
    if (sizeGuideClose) sizeGuideClose.addEventListener('click', closeSizeGuideModal);
    if (sizeGuideOverlay) {
      sizeGuideOverlay.addEventListener('click', function (e) {
        if (e.target === sizeGuideOverlay) closeSizeGuideModal();
      });
    }
    if (sizeGuideModal) {
      selectSizeGuideTab(sizeGuideModal.getAttribute('data-default-tab') || 'men');
      sizeGuideModal.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-lpp-size-tab]');
        if (!tab) return;
        selectSizeGuideTab(tab.getAttribute('data-lpp-size-tab'));
      });
    }
    document.addEventListener('click', function (e) {
      if (!sizeGuideMenu || sizeGuideMenu.contains(e.target)) return;
      setSizeGuideDropdown(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
        closeSizeGuideModal();
        setSizeGuideDropdown(false);
      }
    });

    /* Close notify premium class */
    var notifyClose = document.getElementById('notify-me-close');
    if (notifyClose) {
      notifyClose.addEventListener('click', function () {
        document.getElementById('notify-me-overlay')?.classList.remove('lpp-notify-premium');
      });
    }

    /* ── Mobile sticky ATC bar ── */
    if (stickyBar && settings.mobileStickyAtc) {
      var infoCol = document.getElementById('lpp-info-col');
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBar.classList.toggle('lpp-mobile-sticky-bar--visible', !entry.isIntersecting);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -80px 0px' }
      );
      if (infoCol) observer.observe(infoCol);
    }

  });
})();
